function logPackageVersion() {
  try {
    if (typeof window !== "undefined" && typeof console !== "undefined" && console.log) {
      console.log(`%c@oppein/op-utils v${"1.0.418"}`, "color: #409eff; font-weight: bold;");
    } else if (typeof console !== "undefined" && console.log) {
      console.log(`@oppein/op-utils v${"1.0.418"}`);
    }
  } catch (error) {
    console.warn("Failed to log package version:", error);
  }
}
logPackageVersion();
export { logPackageVersion };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/logVersion.js